import { FieldProps, TimeRangeFieldSchema } from '../types/Form';
import { FieldWrapper } from './FieldWrapper';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { SingleInputTimeRangeField } from '@mui/x-date-pickers-pro';

export const TimeRangeField: React.FC<FieldProps<TimeRangeFieldSchema>> = ({
  name,
  value,
  field,
  errorMessage,
  onChange
}) => {
  const { label, subLabel, containerSx, ...restField } = field;

  return (
    <FieldWrapper
      label={label}
      subLabel={subLabel}
      errorMessage={errorMessage}
      sx={containerSx}
    >
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <SingleInputTimeRangeField
          fullWidth
          data-testid={`time-field-${name}`}
          ampm={false}
          value={value}
          onChange={(e) => onChange(e)}
          {...restField}
        />
      </LocalizationProvider>
    </FieldWrapper>
  );
};
